import { MaritalStatus } from '@tcs/client-portal-api/types/Beneficiaries';
import { useQuery } from 'react-query';

interface Props {
  isLoading: boolean;
  data?: MaritalStatus;
}

export const useMaritalStatus = (
  accountNumber: string,
  options?: { enabled?: boolean }
): Props => {
  const { data, isLoading } = useQuery<MaritalStatus, Error>(
    `/accounts/${accountNumber}/clientMaritalStatus`,
    options
  );
  return {
    isLoading,
    data,
  };
};

export default useMaritalStatus;
